import type { Music24EventProps } from '../../../../../music24-api/src/productEvents/music24EventCatalog';
import { SMLAnalytics } from '../../analytics/sml/analytics';
import type { ShowcaseSignUpPlace, ShowcaseUpsellAction } from './showcaseActions';

/**
 * The analytics of the Studio showcase (spec 2026-10-10 Studio showcase §4). `SMLAnalytics` sends
 * them only after the visitor accepted the cookies (the consent rules of the app; in the embed the
 * choice of music24.com applies, same origin and key).
 */
export const SHOWCASE_EVENTS = {
  opened: 'showcase_opened',
  firstEdit: 'showcase_first_edit',
  upsellShown: 'showcase_upsell_shown',
  signUpClicked: 'showcase_signup_clicked',
} as const;

type ShowcaseEvent = (typeof SHOWCASE_EVENTS)[keyof typeof SHOWCASE_EVENTS];

function track<N extends ShowcaseEvent>(event: N, data?: Music24EventProps<N>): void {
  SMLAnalytics.track(event, data).catch(console.error);
}

/** The demo loaded and the editor opened. */
export function trackShowcaseOpened(isEmbed: boolean): void {
  track(SHOWCASE_EVENTS.opened, { embed: isEmbed });
}

/** The first change of the cut in this visit. */
export function trackShowcaseFirstEdit(): void {
  track(SHOWCASE_EVENTS.firstEdit);
}

/** A sign-up card opened (the dialog of design c2, or the card of a locked tab, c3). */
export function trackShowcaseUpsellShown(action: ShowcaseUpsellAction): void {
  track(SHOWCASE_EVENTS.upsellShown, { action });
}

/** "Start free" or "Sign up free" was pressed. */
export function trackShowcaseSignUpClicked(place: ShowcaseSignUpPlace): void {
  track(SHOWCASE_EVENTS.signUpClicked, { from: place });
}
